import React from 'react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  return <section className="bg-brand-red text-white py-16 px-4 text-center" data-id="element-205">
      <div className="max-w-4xl mx-auto" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-207">
          <span className="text-6xl mb-6 block" data-id="element-208">🔥</span>
          <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-209">
            No necesitás cocinar perfecto.
            <br data-id="element-210" />
            <span className="text-brand-yellow" data-id="element-211">
              Necesitás un sistema que funcione.
            </span>
          </h2>
          <p className="text-2xl md:text-3xl font-bold opacity-90" data-id="element-212">
            Y eso es exactamente lo que te da este e-book.
          </p>
        </motion.div>
      </div>
    </section>;
}